import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { GesturePatternPreview } from './GesturePatternPreview';
import { CombatPhaseLength } from '../../../shared/combat/CombatPhaseLength';
import { EnemyCombatPresetEditorRoundGesturePatternSelection } from './EnemyCombatPresetEditorRoundGesturePatternSelection';
import { undoableClearShowEnemyCombatPresetGesturePatternSelection, undoableSetShowEnemyCombatPresetGesturePatternSelection } from '../../stores/undo/operation/CombatSetShowEnemyCombatPresetGesturePatternSelectionOp';
import { combatEditorStore } from '../../stores/CombatEditorStore';
import { combatStore } from '../../stores/CombatStore';
const Container = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRound__Container",
  componentId: "sc-1bejnru-0"
})(["margin:1em 0.5em;padding:0.5em;box-shadow:0 0 0.5em 0 #555;"]);
const FlexLeftRightContainer = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRound__FlexLeftRightContainer",
  componentId: "sc-1bejnru-1"
})(["display:flex;justify-content:space-between;"]);
const NameContainer = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRound__NameContainer",
  componentId: "sc-1bejnru-2"
})(["flex-shrink:0;"]);
const GesturePatternContainer = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRound__GesturePatternContainer",
  componentId: "sc-1bejnru-3"
})(["flex:1;display:flex;flex-wrap:wrap;margin-left:2em;margin-bottom:0.5em;padding:0 0.25em;max-width:440px;min-height:calc(56.25px + 1em);& > *{margin:0.5em 0.25em;}"]);
const NoGesturesSelected = styled.div.withConfig({
  displayName: "EnemyCombatPresetEditorRound__NoGesturesSelected",
  componentId: "sc-1bejnru-4"
})(["user-select:none;color:red;"]);
const EditGesturePatternsButton = styled.button.withConfig({
  displayName: "EnemyCombatPresetEditorRound__EditGesturePatternsButton",
  componentId: "sc-1bejnru-5"
})(["margin:0.5em 0.25em;height:56.25px;"]);
export const EnemyCombatPresetEditorRound = observer(({
  round,
  enemyCombatPreset,
  roundIndex
}) => {
  const {
    t
  } = useTranslation();
  const sortedGesturePatterns = combatStore.config.gesturePatterns.filter(pattern => round.hasPlayerDefensePatternId(pattern.$modelId));
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FlexLeftRightContainer, null, /*#__PURE__*/React.createElement(NameContainer, null, t("editor.combat_enemy_combat_preset_round", {
    round: roundIndex + 1
  }), "\xA0", /*#__PURE__*/React.createElement("button", {
    onClick: () => enemyCombatPreset.removeRound(roundIndex)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMinusCircle
  }))), /*#__PURE__*/React.createElement(GesturePatternContainer, {
    onClick: () => undoableSetShowEnemyCombatPresetGesturePatternSelection(round)
  }, sortedGesturePatterns.map(pattern => /*#__PURE__*/React.createElement(GesturePatternPreview, {
    key: pattern.$modelId,
    gesturePattern: pattern,
    width: 100
  })), sortedGesturePatterns.length === 0 && /*#__PURE__*/React.createElement(NoGesturesSelected, null, t("editor.combat_enemy_combat_preset_round_no_gestures_selected"))), /*#__PURE__*/React.createElement(EditGesturePatternsButton, {
    onClick: () => undoableSetShowEnemyCombatPresetGesturePatternSelection(round)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSearchPlus
  })), combatEditorStore.showEnemyCombatPresetGesturePatternSelectionRoundModelId === round.$modelId && /*#__PURE__*/React.createElement(EnemyCombatPresetEditorRoundGesturePatternSelection, {
    round: round,
    closePopup: undoableClearShowEnemyCombatPresetGesturePatternSelection
  })), /*#__PURE__*/React.createElement(FlexLeftRightContainer, null, /*#__PURE__*/React.createElement("select", {
    value: round.playerAttackPhaseLength,
    onChange: e => round.setPlayerAttackPhaseLength(+e.target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: CombatPhaseLength.Short
  }, t("editor.combat_enemy_combat_preset_round_short_attack_phase")), /*#__PURE__*/React.createElement("option", {
    value: CombatPhaseLength.Long
  }, t("editor.combat_enemy_combat_preset_round_long_attack_phase"))), /*#__PURE__*/React.createElement("select", {
    value: round.playerDefensePhaseLength,
    onChange: e => round.setPlayerDefensePhaseLength(+e.target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: CombatPhaseLength.Short
  }, t("editor.combat_enemy_combat_preset_round_short_defense_phase")), /*#__PURE__*/React.createElement("option", {
    value: CombatPhaseLength.Long
  }, t("editor.combat_enemy_combat_preset_round_long_defense_phase")))));
});